import {Injectable} from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
  HttpResponse
} from '@angular/common/http';
import { Observable, from, of } from 'rxjs';
import { Router } from '@angular/router';
import { tap, finalize, mergeMap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { SharedService } from './shared.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private urlsToNotIntrcept = [    
    "/api/registrations/account-verified",
    "/api/agent/verify-email",
    "/api/agent/forgot-password",
    "/api/aws-settings",
    "/api/ga-settings",
    //public payment
    "/api/publicPayment/GetPaymentUri",
    "/api/publicPayment/ValidatePaymentReferenceNumber",
    "/api/applications/processDataCopy",
    "/version.json"
  ];

  constructor(private router: Router, private sharedService: SharedService, private authService: AuthService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // const token = localStorage.getItem('id_token');

    // if (token) {
    //     req = req.clone({
    //         setHeaders: {
    //           'Authorization': `Bearer ${token}`,
    //           'Access-Control-Allow-Origin': '*'
    //         },
    //       });
    // } else {
    //   //debugger;
    // }

    const urlWithoutQueryString = req.url.indexOf('?') < 0 ? req.url : req.url.split('?')[0];
    const baseURL = this.sharedService.getBaseURL().replace('/api', '');
    const auxilaryUrl = urlWithoutQueryString.replace(baseURL, '');

    return (this.urlsToNotIntrcept.indexOf(auxilaryUrl) < 0 ? this.authService.getToken() : (() => of(null))())
    
      .pipe(mergeMap((token) =>{
        
        if (token) {
            req = req.clone({
                setHeaders: {
                  'Authorization': `Bearer ${token}`,
                  'Access-Control-Allow-Origin': '*'
                },
              });
        } else {
          //debugger;
        }
      
        return next.handle(req)
                  .pipe(tap( (event: HttpEvent<any>) => {
                    if (event instanceof HttpResponse) {
                      
                        // Do nothing
                    }}, (err: any) => {
                      if (err instanceof HttpErrorResponse) {
                        
                        if (err.status === 401) {
                          const route = this.isAgent() ? '/agent-login' : '/login';
                          localStorage.clear();
                          this.router.navigate([route]);
                        }
                      }}),
                      finalize(() => {}));

      }));
     


  }

  isAgent(): boolean {
    return localStorage.getItem('userType') === 'agent';
  }

}
